export default __webpack_public_path__ + "static/1860_1870-ea53d836085667e128495503a615a2ae.jpg";